module.exports = __webpack_public_path__ + "media/add/wheel-mega-4d59c13c.png";